import { useNavigate } from "react-router-dom";
import {
  FaBuilding,
  FaCog,
  FaMapMarkerAlt,
  FaMoneyBillWave,
} from "react-icons/fa";

export default function SettingsPage() {
  const navigate = useNavigate();

  const cards = [
    {
      title: "Business Info",
      desc: "Manage company details",
      icon: FaBuilding({}),
      path: "/settings/business-info",
    },
    {
      title: "Sites & Locations",
      desc: "Manage sites and attendance locations",
      icon: FaMapMarkerAlt({}),
      path: "/settings/sites",
    },
    {
      title: "Payroll & Salary",
      desc: "Configure salary, allowances, deductions and payroll rules",
      icon: FaMoneyBillWave({}),
      path: "/settings/payroll",
    },
  ];

  return (
    <div className="p-4 md:p-6">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">
          Settings
        </h1>

        <p className="mt-1 text-sm text-gray-500">
          Manage your business configuration and system settings.
        </p>
      </div>

      {/* Settings Grid */}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {cards.map((card, idx) => (
          <button
            key={idx}
            type="button"
            onClick={() => navigate(card.path)}
            className="
              group w-full rounded-2xl border border-gray-200
              bg-white p-5 text-left shadow-sm
              transition-all duration-200
              hover:-translate-y-0.5 hover:border-indigo-200
              hover:shadow-md
            "
          >
            {/* Icon */}
            <div
              className="
                mb-4 flex h-11 w-11 items-center justify-center
                rounded-xl bg-indigo-50 text-indigo-600
                transition group-hover:bg-indigo-100
              "
            >
              {card.icon}
            </div>

            {/* Content */}
            <h3 className="text-base font-semibold text-gray-900">
              {card.title}
            </h3>

            <p className="mt-1 text-sm leading-5 text-gray-500">
              {card.desc}
            </p>

            {/* Action */}
            <div className="mt-4 text-xs font-semibold text-indigo-600">
              Manage settings →
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}